import { createActionFactory } from '../../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Common Entities => Winner => ');

const fetch = createAction('fetch draws', (experienceId) => ({ experienceId }));
const fetchSuccess = createAction('fetch draws success', (draws) => ({ draws }));
const fetchFailure = createApiFailureAction('fetch draws failure');

const shuffleDraw = createAction('shuffle draw', (id) => ({ id }));
const reselectDraw = createAction('reselect draw', (id) => ({ id }));
const updateDrawSuccess = createAction('update draw success', (id, draw) => ({ id, draw }));
const updateDrawFailure = createApiFailureAction('update draw failure');

const invalidateWinner = createAction('invalidate winner', (id) => ({ id }));
const validateWinner = createAction('validate winner', (id) => ({ id }));
const reselectWinner = createAction('reselect winner', (id) => ({ id }));
const reselectWinnerSuccess = createAction('reselect winner', (winner, drawId, prevWinnerId) => ({
  winner,
  drawId,
  prevWinnerId,
}));
const reselectWinnerFailure = createApiFailureAction('failed to reselect winner');
const updateWinnerSuccess = createAction('update winner success', (winner) => ({ winner }));
const updateWinnerFailure = createApiFailureAction('update winner failure');

const viewEntry = createAction('view entry', (experienceId, entryId) => ({ experienceId, entryId }));

const pickWinners = createAction('pick winners');

export default {
  fetch,
  fetchSuccess,
  fetchFailure,

  shuffleDraw,
  reselectDraw,
  updateDrawSuccess,
  updateDrawFailure,

  invalidateWinner,
  validateWinner,
  reselectWinner,
  reselectWinnerSuccess,
  reselectWinnerFailure,

  updateWinnerSuccess,
  updateWinnerFailure,

  viewEntry,

  pickWinners,
};
